import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "map-selector animated-fast" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  class: "p-title",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_4 = { class: "p-title-actions" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-pencil" }, null, -1)
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "prop-hiearchy" }
const _hoisted_8 = { class: "prop-section-title" }
const _hoisted_9 = { class: "p-hierarchy-label" }
const _hoisted_10 = { class: "prop-hiearchy" }
const _hoisted_11 = { class: "prop-section-title" }
const _hoisted_12 = { class: "p-hierarchy-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_btn = _resolveComponent("imdex-btn")!
  const _component_imdex_text_field = _resolveComponent("imdex-text-field")!
  const _component_imdex_radio = _resolveComponent("imdex-radio")!
  const _component_GradientImage = _resolveComponent("GradientImage")!
  const _component_EditGradients = _resolveComponent("EditGradients")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.editGradients)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.$t(`ssa.displayPane.colorGeneral.gradients`)) + " ", 1),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_imdex_btn, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editGradients = true)),
                mini: "",
                text: "",
                secondary: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            true
              ? (_openBlock(), _createBlock(_component_imdex_text_field, {
                  key: 0,
                  text: "text",
                  small: "",
                  label: _ctx.$t(`ssa.displayPane.colorGeneral.searchInputLabel`),
                  value: _ctx.searchTerm,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchTerm) = $event)),
                  leadingIcon: "fal fa-search"
                }, null, 8, ["label", "value"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t(`ssa.displayPane.colorGeneral.continuous`)), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.continuous, (item, c) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "p-hierarchy-item",
                  key: c
                }, [
                  _createVNode(_component_imdex_radio, {
                    value: _ctx.selectedMap,
                    onClick: ($event: any) => (_ctx.setColorMap(item)),
                    val: item.id
                  }, null, 8, ["value", "onClick", "val"]),
                  _createVNode(_component_GradientImage, {
                    rgbPoints: item.rgbPoints,
                    size: [30, 30]
                  }, null, 8, ["rgbPoints"]),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(item.text), 1)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t(`ssa.displayPane.colorGeneral.continuousFixed`)), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.continuousFixed, (item, c) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "p-hierarchy-item",
                  key: c
                }, [
                  _createVNode(_component_imdex_radio, {
                    value: _ctx.selectedMap,
                    onClick: ($event: any) => (_ctx.setColorMap(item)),
                    val: item.id
                  }, null, 8, ["value", "onClick", "val"]),
                  _createVNode(_component_GradientImage, {
                    rgbPoints: item.rgbPoints,
                    size: [30, 30]
                  }, null, 8, ["rgbPoints"]),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(item.text), 1)
                ]))
              }), 128))
            ])
          ])
        ]))
      : (_openBlock(), _createBlock(_component_EditGradients, {
          key: 1,
          onUpdateColorMap: _ctx.updateColorMap,
          onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editGradients = false)),
          continuous: _ctx.colorPresets,
          continuousFixed: _ctx.fixedColorPresets
        }, null, 8, ["onUpdateColorMap", "continuous", "continuousFixed"]))
  ]))
}